import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { first, pairwise, startWith } from 'rxjs';
import { ContactAuthorityService } from 'src/app/modules/setting/contact-setting/services/contact-authority.service';

@Component({
    selector: 'app-final-preview-contact',
    templateUrl: './final-preview-contact.component.html',
    styleUrls: ['./final-preview-contact.component.scss'],
    standalone: false
})
export class FinalPreviewContactComponent implements OnInit, OnChanges {

  @Input() model: any = {};
  @Input() form: any = {};
  @Input() isEdit : boolean = false;
  @Output() callback = new EventEmitter<any>(true);

  public contact: any = {};
  public contactAuthorities: any[] = [];

  constructor(private contactAuthorityService: ContactAuthorityService) { }

  ngOnChanges(changes: SimpleChanges) {
    this.model = changes?.model?.currentValue;
    this.isEdit = changes?.isEdit?.currentValue;
    //this.contact = this.model;
    this.form.get('step01').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.contact = next?.contact;
      });
  }

  ngOnInit(): void {
    this.contactAuthorityService.getList({ per_page: 999 })
      .pipe(first())
      .subscribe((data: any) => {
        this.contactAuthorities = data?.data ?? [];
      });
  }

  getContactAuthorityTitle(id: any): string {
    if (!id) return '';
    const authority = this.contactAuthorities.find((a: any) => String(a.id) === String(id));
    return authority?.title ?? '';
  }

}
